module.exports = __webpack_public_path__ + "static/media/edit-doc.d0fa90a5.svg";